import { Skeleton, SkeletonCircle } from '@chakra-ui/react';
import HeaderTabSelector from '@/components/HeaderTabSelector';
import PageSmallTitle from '@/components/PageSmallTitle/PageSmallTitle.component';
import PTORequestsList from '@/components/PTORequestsList';
import PTORequestsScheduleList from '@/components/PTORequestsScheduleList';
import Pagination, { PaginationTypes } from '@/trio-ui/Pagination';
import { PTORequest } from '@/types/api';
import * as Styles from './PTORequests.styles';

type PTORequestsComponentProps = PaginationTypes & {
  ptoRequestList?: PTORequest[];
  isLoadingPTOs?: boolean;
  filter: Filter;
  onChangeFilter?: (filter: Filter) => void;
  onUpdatePTO?: () => void;
};

export type Filter = 'Unanswered' | 'All' | 'Schedule';
const filters: Filter[] = ['Unanswered', 'All', 'Schedule'];

const PTORequestsComponent = function ({
  ptoRequestList = [],
  lastPage,
  currentPage,
  itemsPerPage,
  count,
  onChangeRecordsPerPage,
  onChangePageHandler,
  filter,
  onChangeFilter,
  isLoadingPTOs = false,
  onUpdatePTO,
}: PTORequestsComponentProps): JSX.Element {
  return (
    <>
      <Styles.Header>
        <PageSmallTitle title="PTO Requests" />
        <HeaderTabSelector options={filters} value={filter} onChange={onChangeFilter} />
      </Styles.Header>
      {filter === 'Schedule' ? (
        <PTORequestsScheduleList
          ptos={ptoRequestList}
          isLoadingPTOs={isLoadingPTOs}
          onUpdateRequest={onUpdatePTO}
        />
      ) : (
        <>
          {isLoadingPTOs ? (
            <div className="tw-border tw-bg-neutral-0 tw-border-neutral-40 tw-rounded-lg tw-divide-y tw-divide-neutral-30">
              {[...Array(itemsPerPage).keys()].map((key) => (
                <div className="tw-grid tw-grid-cols-pto-request-item" key={key + 1}>
                  <div className="tw-py-2 tw-px-4 tw-flex tw-gap-[15px]">
                    <SkeletonCircle w={9} h={9} />
                    <div>
                      <div className="tw-flex tw-gap-4 tw-h-[21px] tw-items-center">
                        <Skeleton className="tw-h-3.5 tw-w-[100px]" />
                        <Skeleton className="tw-h-3 tw-w-[70px]" />
                      </div>
                      <div className="tw-flex tw-gap-1 tw-h-[21px] tw-items-center">
                        <Skeleton className="tw-h-3.5 tw-w-[180px]" />
                        <Skeleton className="tw-h-3.5 tw-w-[140px]" />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <PTORequestsList
              ptoRequestList={ptoRequestList}
              onUpdate={onUpdatePTO}
              filter={filter}
            />
          )}
          {!isLoadingPTOs && (
            <Pagination
              onChangeRecordsPerPage={onChangeRecordsPerPage}
              lastPage={lastPage}
              itemsPerPage={itemsPerPage}
              count={count}
              currentPage={currentPage}
              onChangePageHandler={onChangePageHandler}
            />
          )}
        </>
      )}
    </>
  );
};

export default PTORequestsComponent;
